"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _material = require("@mui/material");
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _getResource = require("../../utilities/getResource");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = function styles(theme) {
  return {
    radioButton: {
      display: 'flex',
      alignItems: 'center',
      padding: 0
    },
    paperAnswer: {
      textAlign: 'center',
      backgroundColor: 'transparent !important',
      wordBreak: 'break-word'
    },
    paperQuestion: {
      textAlign: 'left',
      backgroundColor: 'transparent !important',
      wordBreak: 'break-word'
    },
    rowAction: {
      fontSize: '0.75rem',
      color: theme.palette.primary[500],
      cursor: 'pointer',
      backgroundColor: 'transparent'
    },
    gridRow: {
      padding: '0.4em',
      '&:nth-child(odd)': {
        backgroundColor: '#eceded'
      }
    }
  };
};
var CustomMatrixQuestion = /*#__PURE__*/function (_Component) {
  function CustomMatrixQuestion(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, CustomMatrixQuestion);
    _this = _callSuper(this, CustomMatrixQuestion, [props]);
    (0, _defineProperty2["default"])(_this, "handleChange", function (event) {
      var question = _objectSpread(_objectSpread({}, _this.state.question), {}, {
        value: event.target.value
      });
      _this.setState({
        question: question
      });
      _this.props.onChange(question);
    });
    _this.state = {
      question: {}
    };
    _this.handleChange = _this.handleChange.bind(_this);
    _this.clearSelection = _this.clearSelection.bind(_this);
    _this.loadPreviousAnswer = _this.loadPreviousAnswer.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(CustomMatrixQuestion, _Component);
  return (0, _createClass2["default"])(CustomMatrixQuestion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var question = this.props.question;
      this.setState({
        question: question
      });
    }
  }, {
    key: "clearSelection",
    value: function clearSelection() {
      this.setState({
        question: _objectSpread(_objectSpread({}, this.state.question), {}, {
          value: null
        })
      });
      this.props.onChange(_objectSpread(_objectSpread({}, this.state.question), {}, {
        value: null
      }));
    }
  }, {
    key: "loadPreviousAnswer",
    value: function loadPreviousAnswer() {
      this.setState({
        question: _objectSpread(_objectSpread({}, this.state.question), {}, {
          value: this.state.question.previousValue
        })
      });
      this.props.onChange(_objectSpread(_objectSpread({}, this.state.question), {}, {
        value: this.state.question.previousValue
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        answers = _this$props.answers,
        classes = _this$props.classes,
        question = _this$props.question,
        resources = _this$props.resources,
        language = _this$props.language;
      var questionText = '';
      if (language && question.translations && question.translations[language]) {
        questionText = question.translations[language];
      } else {
        questionText = question.text;
      }
      return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        className: classes.gridRow
      }, /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        item: true,
        xs: 6,
        alignContent: "center"
      }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
        elevation: 0,
        className: classes.paperQuestion
      }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        style: {
          backgroundColor: "transparent"
        }
      }, questionText))), answers.map(function (answer, index) {
        return /*#__PURE__*/_react["default"].createElement(_material.Grid, {
          item: true,
          xs: true,
          key: index
        }, /*#__PURE__*/_react["default"].createElement(_material.Paper, {
          elevation: 0,
          className: classes.paperAnswer
        }, /*#__PURE__*/_react["default"].createElement(_material.Radio, {
          value: answer.value,
          checked: question.value == answer.value,
          name: question.text,
          className: classes.radioButton,
          onChange: _this2.handleChange
        })));
      }), /*#__PURE__*/_react["default"].createElement(_material.Grid, {
        container: true,
        item: true,
        xs: true,
        alignContent: "center"
      }, this.state.question.value && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        className: classes.rowAction,
        onClick: this.clearSelection
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Clear Selection')), this.state.question.previousValue && this.state.question.previousValue != this.state.question.value && /*#__PURE__*/_react["default"].createElement(_material.Typography, {
        className: classes.rowAction,
        onClick: this.loadPreviousAnswer
      }, (0, _getResource.getResource)(resources, language, 'Label', 'Prior Answer'))));
    }
  }]);
}(_react.Component);
CustomMatrixQuestion.propTypes = {
  answers: _propTypes["default"].array
};
var _default = exports["default"] = (0, _styles.withStyles)(styles)(CustomMatrixQuestion);